'use strict';
var processInclude = require('base/util');
var base = require('./base');
var focusHelper = require('base/components/focus');
var baseQuickView = require('base/product/quickView');

$(document).ready(function() {
    processInclude(require('./detail'));
    processInclude(require('./pdpProductDetails'));
});

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="quickViewModal" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog quick-view-dialog modal-dialog-centered">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-body custom-scrollbar"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl, el) {
    $('.modal-body')
        .spinner()
        .start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function(data) {
            var parsedHtml = parseHtml(data.renderedTemplate),
                uniqueSellingPropsCopy = el.parent('.product-detail').find('.unique-selling-props-copy').clone();

            $('.quick-view-dialog .modal-body').empty();
            $('.quick-view-dialog .modal-body').html(parsedHtml.body);
            $('.quick-view-dialog .modal-footer').html(parsedHtml.footer);
            $('.full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal .unique-selling-props-container').append(uniqueSellingPropsCopy);
            $('#quickViewModal').modal('show');

            $.spinner().stop();
        },
        error: function() {
            $.spinner().stop();
        }
    });
}

module.exports = {
    showQuickview: function() {
        $('body').on('click', '.quickview', function(e) {
            e.preventDefault();
            var $this = $(this),
                selectedValueUrl = $this
                .closest('a.quickview')
                .attr('href');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl, $this);
        });
    },
    focusQuickview: function() {
        $('body').on('shown.bs.modal', '#quickViewModal', function() {
            $('#quickViewModal .close').focus();
        });
    },
    trapQuickviewFocus: function() {
        $('body').on('keydown', '#quickViewModal', function(e) {
            var focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    availability: base.availability,
    showSpinner: baseQuickView.showSpinner,
    hideDialog: baseQuickView.hideDialog,
    beforeUpdateAttribute: baseQuickView.beforeUpdateAttribute,
    updateAttribute: baseQuickView.updateAttribute,
    updateAddToCart: baseQuickView.updateAddToCart,
    updateAvailability: baseQuickView.updateAvailability
};

$(document).on('click', '.pdp-sizeGuide-modal .close', function() {
    $('#pdp-sizeGuide').remove();
});

$(document).on('show.bs.modal', '#quickViewModal', function() {
    $('.pdp-sizeGuide-modal .close').removeAttr('data-dismiss');
    $('.modal-body .swatch-circle').each(function(i, d) {
        if ($(d).hasClass('selected')) {
            var swatchVal = $(d).data('attr-value');
            $('.selected-color').text(swatchVal.toLowerCase());
        }
    });

    var tElement = document.querySelector('.product-desc .value');
    if (tElement != null) {
        var tElementText = tElement.innerText;
        var ellipsisText = EllipsisChar(tElementText, 168);
        tElement.innerText = ellipsisText;
    }
});

function EllipsisChar(text, size) {
    var len = text.length;

    if (len >= size) {
        text = text.substring(0, 168) + '...';
    }

    return text;
}
$(document).on('hidden.bs.modal', '#quickViewModal', function() {
    $('.modal-backdrop').remove();
});
